import { observer } from "mobx-react-lite";
import { useEffect } from "react";
import { useLocation, useParams } from "react-router-dom";
import RouterConstants from "../../../../../../constants/RouterConstants";
import useSecureNavigate from "../../../../../../hooks/useSecureNavigate";
import { useAppStore } from "../../../../../../hooks/useStores";
import TgDatasetEditor from "../../../../Datasets/Editor/TgDatasetEditor";
import { TgDataset, defaultDataset } from "../../../../Datasets/store/tg-dataset-store";
import { defaultModel } from "../../../../Models/store/tg-model-store.tsx";

export type EditTgProjectDatasetLocationState = {
	datasetToEdit?: TgDataset;
};

export const EditTgProjectDataset = () => {
	const { datasetId } = useParams();
	const navigate = useSecureNavigate();
	const location = useLocation();
	const { tgStore } = useAppStore();
	const { tgModelStore, tgDatasetStore } = tgStore;

	useEffect(() => {
		tgDatasetStore.datasetForm = location.state?.datasetToEdit ?? defaultDataset;

		(async () => {
			try {
				if (!location.state?.datasetToEdit && datasetId) {
					const dataset = await tgDatasetStore.getDataset(Number(datasetId));
					tgDatasetStore.datasetForm = dataset;
				}
			} catch (err: any) {
				if (err.response?.status === 404) {
					navigate(RouterConstants.NEW_TG.fullPath);
				}
			}
		})();

		return () => {
			tgModelStore.isDatasetFromExisting = false;
			tgDatasetStore.datasetForm = defaultDataset;
			tgModelStore.modelForm = defaultModel;
			tgDatasetStore.isFormDuplicateTriggered = false;
			window.history.replaceState({}, "");
			tgDatasetStore.csvUploadErrors = [];
			tgDatasetStore.csvUploadWarnings = [];
		};
	}, []);

	return <TgDatasetEditor />;
};

export default observer(EditTgProjectDataset);
